export const UNDO: string = 'undo';
export const REDO: string = 'redo';
export const INIT: string = 'init';
export const RESOLVED: string = 'resolved';
export const PENDING: string = 'pending';
export const MAX_ENTRIES_COUNT: number = 100;